// extracted by mini-css-extract-plugin
export default {"cls1":"FeatureFeedback-cls1_HZa","cls2":"FeatureFeedback-cls2_lAU FeatureFeedback-cls1_HZa"};